/* unplugin-vue-components disabled */import { render } from "./UploadIconSVG.vue?vue&type=template&id=64a8fb65"
import script from "./UploadIconSVG.vue?vue&type=script&lang=js"
export * from "./UploadIconSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__